import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-packaging-waste-management',
  templateUrl: 'packaging-waste-management.component.html',
  styleUrls: ['./packaging-waste-management.component.scss'],
})
export class PackagingWasteManagementComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
